import { render, staticRenderFns } from "./NotificationObstacleDetectionQuestionnaire.vue?vue&type=template&id=4e9c3805&scoped=true&"
import script from "./NotificationObstacleDetectionQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./NotificationObstacleDetectionQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationObstacleDetectionQuestionnaire.vue?vue&type=style&index=0&id=4e9c3805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c3805",
  null
  
)

export default component.exports